const intents = {
    possibleIntents: {
        changeValue: 'changeValue',
        changeAttribute: 'changeAttribute',
        changeClass: 'changeClass',
        changeText: 'changeText',
        changeLink: 'changeLink'
    },
    defaultIntent: 'changeAttribute'
};

export default intents;


// WEBPACK FOOTER //
// ./src/fixtures/Intents.js